import React from 'react';
import { useNavigate } from 'react-router-dom';

const Forbidden403 = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const navigate = useNavigate();


    const redirect = () => {
        if (user.roleName == 'it_admin') {
            navigate('/it_admin/users')
        } else if (user.roleName == 'dealer') {
            navigate(`/customer/dashboards`)
        }
        else {
            navigate(`/${user.roleName}/dashboard`)
        }
    }

    return (
        <div style={styles.container}>
            <h1>403 Forbidden</h1>
            <img src={'/403.svg'} alt="403 Forbidden" style={styles.image} />
            <p>You don't have permission to access this page.</p>
            <button style={styles.button} onClick={() => { redirect() }}>Go to Dashboard</button>
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f3f4f6',
        color: '#333',
        textAlign: 'center',
    },
    image: {
        maxWidth: '30%',
        marginBottom: '1rem',
    },
    button: {
        padding: '10px 20px',
        fontSize: '1rem',
        color: '#fff',
        backgroundColor: '#556ee6',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        marginTop: '1rem',
    }
}


export default Forbidden403;